import { isEqualTime } from "~/tools/date-time";
import type { Time } from "~/tools/date-time/time";
import { Impulse, type Scope } from "~/tools/impulse";
import { isPresent } from "~/tools/is-present";
import type { Point } from "~/tools/point";

import { type TimelineEventBucket, type TimelineEventCategory, getTimelineEventBucketStartTime } from "./domain";

export interface TimelineHoveredEventBucket {
	eventCategory: TimelineEventCategory;
	bucket: TimelineEventBucket;
	position: Point;
}

export class TimelineEventBucketsState {
	private readonly bucketPopup = Impulse<TimelineHoveredEventBucket>();
	public readonly hoveredBucket = Impulse<TimelineHoveredEventBucket>();

	public getBucketPopup(scope: Scope): undefined | TimelineHoveredEventBucket {
		return this.hoveredBucket.getValue(scope) ?? this.bucketPopup.getValue(scope);
	}

	public setBucketPopup(event: undefined | TimelineHoveredEventBucket): void {
		this.bucketPopup.setValue(event);
	}

	public isBucketPopupHovered(scope: Scope): boolean {
		return isPresent(this.bucketPopup.getValue(scope));
	}

	public isBucketHovered(scope: Scope, eventCategory: TimelineEventCategory, startTime: Time): boolean {
		const hovered = this.getBucketPopup(scope);

		if (hovered?.eventCategory !== eventCategory) {
			return false;
		}

		return isEqualTime(getTimelineEventBucketStartTime(hovered.bucket), startTime);
	}
}
